import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileExport,
    faEye
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment'

const TableRow = (props) => {
    const openDrawer = () => {
        props.onChatButtonClick(props.row);
    }
    
    return (
        <tr className="">
            <td>
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Date Time
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {moment(props.row.created_at).format("D MMM YYYY, H:mm")}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Session Duration
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {props.row.duration}
                            </span>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <span className="text-gray-600 fw-semibold d-block fs-7">
                                {props.row.user_source}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <span className="badge badge-light-success">
                            {props.row.unique_ip == "Yes" ? "Unique" : ""}
                        </span>
                    </div>
                </div>
            </td>
            <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.name}
                            </a>
                            <span>
                                <div className="badge badge-light-dark fw-bold">
                                    {props.row.mobile_number}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                {/* <div className='row'>
                    <div className='col-md-12'>
                        <span className="me-2">
                            <div className="badge badge-light fw-bold mb-1">
                                Product 1
                            </div>
                        </span>
                        <span className="me-2">
                            <div className="badge badge-light fw-bold mb-1">
                                Product 2
                            </div>
                        </span>
                    </div>
                </div> */}
            </td>
            <td>
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Transfered User
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {props.row.transfer_by}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Date Time
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {moment(props.row.transfer_on).format("D MMM YYYY, H:mm")}
                            </span>
                        </div>
                    </div>
                </div>
            </td>
            <td className='text-end'>
                <button className='btn btn-dark btn-sm btn-icon' onClick={openDrawer}>
                    <FontAwesomeIcon icon={faEye} />
                </button>
            </td>
        </tr>
    )
}

export default TableRow;